import carousel from 'vue-owl-carousel';

export default {
  components: {
    carousel,
  },
};
